<template>
  <div class="d-flex flex-column result-display">
    <div class="sortition-name text-center text-yellow">
      {{ result.sortition.name }}
    </div>
    <div class="sortition-date text-center text-yellow">{{ result.date }}</div>
    <v-row no-gutters>
      <v-col md="6" lg="6" class="align-self-center border-right">
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.first"
              text="1st"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.second"
              text="2nd"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.third"
              text="3rd"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" lg="6">
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="20" contain :src="require('assets/static/img/picks/fastpay/pick2.png')" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickTwo"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="20" contain :src="require('assets/static/img/picks/fastpay/pick3.png')" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.cashThree"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="20" contain :src="require('assets/static/img/picks/fastpay/pick4.png')" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickFour"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row v-if="result.pickFive" no-gutters>
          <v-col cols="12">
            <v-img height="20" contain :src="require('assets/static/img/picks/fastpay/pick5.png')" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickFive"
            ></result-digit-display>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResultDigitDisplay from "./ResultDigitDisplay.vue";

export default {
  name: "ResultDisplay",
  components: { ResultDigitDisplay },
  props: {
    result: {
      type: Object,
      required: true
    },
    white: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style scoped lang="scss">
@import "css/variables";

.sortition-name {
  line-height: 25px;
  font-size: 1.7rem;
  font-weight: bold;
}

.text-yellow {
  color: $darkblue;
}

.next-drawing-text {
  color: $darkblue;
}

.sortition-date {
  font-size: 1.1rem;
}

.first,
.second,
.third {
  display: flex;
  flex-direction: column;
  margin-top: 0;

  .header {
    line-height: 35px;
    text-align: center;
  }
}

.border-right {
  padding-right: 15px;
  border-right: $darkblue solid 5px;
}
</style>
